<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    <path d="M18.75,10.063V6.748a6.75,6.75,0,0,0-13.5,0v3.315A4.986,4.986,0,0,0,2.5,14.5V19a5.005,5.005,0,0,0,5,5h9a5.005,5.005,0,0,0,5-5V14.5A4.986,4.986,0,0,0,18.75,10.063ZM14,16.452a2,2,0,1,1-2-2A2,2,0,0,1,14,16.452ZM12,2.5a4.255,4.255,0,0,1,4.25,4.249V9a.5.5,0,0,1-.5.5H8.25a.5.5,0,0,1-.5-.5V6.748A4.255,4.255,0,0,1,12,2.5Z"/>
  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'lock-6',
    },
    name: {
      type: String,
      required: false,
      default: 'Lock6',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>